import { useEffect } from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { COOKIE_NAME } from '../constants';
import { useSelector } from 'react-redux';
import { selectDatesValue } from 'shared/selectors/filters';
import { trackOpenDatesModal } from '../tracking';
import { deleteCookie } from '@cian/utils/lib/browser/cookie';

export const useAnalytics = () => {
  const { config } = useApplicationContext();

  const dates = useSelector(selectDatesValue);

  useEffect(() => {
    const isDatesModalAutoOpenRSEnabled = config.get<boolean>('Dailyrent.DatesAutoOpen.Enabled');
    const hasSkipCookie = document.cookie.includes(COOKIE_NAME);

    const { from, to } = dates;
    const hasDates = from && to;

    if (isDatesModalAutoOpenRSEnabled && !hasDates && !hasSkipCookie) {
      trackOpenDatesModal();
    }

    if (hasSkipCookie) {
      deleteCookie(COOKIE_NAME);
    }
  }, [config, dates]);
};
